module.exports = __webpack_public_path__ + "static/media/habit-planning.24a0268a.png";